import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Home from '@/views/Home/index'

export const constantRoutes=[
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    component:()=>import('@/views/homepage'),
    name:'Home Page',
    meta:{title: '主页'},
  },

  {
    path: '/other',
    component: Home,
    children:[
      {
        path:'/cart',
        name:'cart',
        component:()=>import('@/views/Cart'),
        hidden: true
      },
      {
        path: '/my-order',
        name: 'MyOrder',
        component: () => import('@/views/myorder'),
        hidden: true,
        meta:{Auth:true}
      },
    ],
  },
  {
    path: '/socialstats',
    component: Home,
    redirect : '/socialstats/province',
    name: 'socialstats',
    meta:{title: '社会统计数据（中国大陆经济区）'},
    children: [
      {
        path: 'province',
        component: () => import('@/views/socialstats/index'),
        name: 'province',
        meta: {title: '全国及省级总体数据（年度）', cate_code: 'SPAY'}
      },
      {
        path: 'industry',
        component: () => import('@/views/socialstats/index'),
        name: 'industry',
        meta: { title: '全国及省级分三次产业数据（年度）',cate_code: 'SPEY'},
      },
      {
        path: 'sector',
        component: () => import('@/views/socialstats/index'),
        name: 'sector',
        meta: { title: '全国及省级分行业数据（年度）',cate_code: 'SPHY'},
      },
      {
        path: 'city',
        component: () => import('@/views/socialstats/index'),
        name: 'city',
        meta: { title: '地级市数据（年度）', cate_code: 'SC' }
      },
    ]
  },
  {
    path: '/grids',
    component: Home,
    redirect: '/grids/11/1',
    name: 'grids',
    meta: { title: '空间栅格数据（中国）' },
    children:[
      {
        path: '11',
        component:() => import('@/views/grids/index'),
        name: '11',
        meta: {title: '夜间灯光数据（年度）'},
        children: [
          {
            path:'1',
            component: ()=> import('@/views/grids/index'),
            name:'VIIRS',
            meta: {title: 'NPP-VIIRS (2012-2021)', cate_code: 'G11'}
          },
          {
            path: '2',
            component: ()=> import('@/views/grids/index'),
            name:'DMSP',
            meta: {title: '合成DMSP (1992-2021)', cate_code: 'G11'}
          },
        ]
      },
      {
        path: '12',
        name: 'Net_Co2',
        component: ()=> import('@/views/grids/index'),
        meta: {title: '空间二氧化碳（年度）'},
        children:[
          {
            path:'1',
            component: ()=> import('@/views/grids/index'),
            name:'ODIAC',
            meta: {title: 'ODIAC (2000-2021)', cate_code: 'G12'}
          },
          {
            path: '2',
          }
        ]
      }
    
    ]
  },

  {
    path: '/login',
    component:()=>import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/login/privacy',
    component:()=>import('@/views/login/privacy'),
    hidden: true
  },
  {
    path: '/login/service',
    component:()=>import('@/views/login/service'),
    hidden: true
  },

  {
    path:'/order-detail',
    component:()=>import('@/views/OrderDetail'),
    hidden: true,
    meta:{Auth:true}
  },
]

const createRouter=()=>new Router({
  mode: 'history',
  routes: constantRoutes
})

const router=createRouter()

// export function resetRouter(){
//   const newRouter=createRouter()
//   router.matcher=newRouter.matcher
// }

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this,location).catch(err => err)
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js